<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-layout
      justify-center
      wrap
    >

      <v-flex cols="12">
          <v-form
                  v-model="valid"
                  lazy-validation
                  ref="form"
                  id="new-patient-form">
        <material-card
          color="green"
          title="إجراء طلب جديد"
          text="يرجى ادخال معلومات البيانات بشكل صحيح لإجراء الطلب"
        >

            <v-container>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-autocomplete
                      v-model="patientid"
                      :items="mypatients"
                      item-text="text"
                      label="إسم المراجع"
                  >
                  </v-autocomplete>
                </v-flex>

                  <v-flex xs12 md6>
                  <v-text-field v-model="barcode" :rules="[rules.required]" label="رقم العينة" />
                  </v-flex>

                <v-flex
                  xs12
                  md6
                >
                  <v-autocomplete
                    v-model="dst"
                    :items="groups"
                    :rules="[rules.required]"
                    label="إرسال الى ..."></v-autocomplete>
                </v-flex>
               <v-flex
                   xs12
                   md6>
                   <v-text-field
                           v-model="reason"

                           label="السبب"></v-text-field>
                </v-flex>



                <v-flex xs12>
                    <v-textarea
                            rows="2"
                            v-model="notes"
                            label="الملاحظات: مثال العدد / التاريخ ... "></v-textarea>
                </v-flex>

              </v-layout>
            </v-container>

        </material-card>
          </v-form>
      </v-flex>
      <v-flex
                  md12
                  xs12
                  text-xs-right
                    >
                    <v-btn
                            @click="validateFunc"
                            :disabled="!valid"
                            form="new-patient-form"
                            class="mx-0 font-weight-bold"
                            color="success"
                    >
              إرسال الطلب
            </v-btn>

        </v-flex>

      </v-layout>

  </v-container>
</template>

<script>

import {__HTTP,FormHeader} from '@/utils/utils';


  export default {
    computed: {
      mypatients() {
        return this.patients
      },
    },
    data: () => ({
        // Validation Rules
        rules: {
          required: value => !!value || 'هذا الحقل مطلوب',
          counter: value => value.length <= 40 || 'الحد الأقصى هو 40 حرف',
          phonecounter: value =>  {
            const pattern = /^0?7[0-9]{9,9}$/;

            return pattern.test(value) || 'رقم الهاتف غير صحيح'
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'البريد الالكتروني غير صحيح'
          },
          strength: value => {
            const pattern = /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/
            return pattern.test(value) || 'يجب ان تكون كلمة السر مكونة حروف كبيرة، حروف صغيرة,ارقام , علامات خاصةو لاتقل عن ٦ ارقام او حروف'
          },
        },
        patients: [],
        valid: true,
        dst: '',
        notes: '',
        barcode: '',
        reason: '',
        groups: [],
        patientid: '',
        patientname: '',

    }),
    mounted() {
      if (this.$route.params.id) {
        this.patientid = this.$route.params.id;
      }

    },
    created() {
      this.getPatients();
      this.getGroups();
    },
    methods: {
        /*
        getPatientInfo() {
          Axios.post("https://cphl.esite-lab.com/?do=getpatientinfo&id="+this.$route.params.id).then((res) => {
            this.isloading = false
            if (res.data.auth == true) {
              this.patientname = res.data.fullname

            }
          })
        },
         */
      getPatients() {
        __HTTP("?do=getmypatients",{},FormHeader,(res) => {
          res.map((i) => {
            this.patients.push(
                {
                  text: i.fullname,
                  value: i.id
                });
          })
          this.getFollowUp();
        })
      },

        Rules(type) {
            return this.$store.state.appRules[type];
            },
        getGroups() {
          __HTTP("?do=getgroups",{},FormHeader,(res) => {
            res.map((i) => {
              this.groups.push({
                text: i.title,
                value: i.id
              });
            });

          });
        },
        validateFunc() {
        //console.log("btnClicked")
        if (this.$refs.form.validate()) {
          this.submitForm()
        }
      },
      submitForm() {
          console.log({
            dst: this.dst,
            notes: this.notes,
            barcode: this.barcode,
            patientid: this.patientid,
            reason: this.reason,
          });
        __HTTP("?do=newaction",{
          dst: this.dst,
          notes: this.notes,
          barcode: this.barcode,
          patientid: this.patientid,
          reason: this.reason,
        },FormHeader,(res) => {
          if (res.auth == true) {
            this.$router.push({name: 'ListActions'})
          }
        });
      }
    }
  }
</script>
